query UnitSettings($orgId: ID!) {
  admin_unitSettings(orgId: $orgId) {
    boundaryEnforced
    endUsersLaunched
  }
}
